import { t } from "../i18n";
import { useHighlight } from "../state/highlight";
import { useCadForm } from "./formContext";
export function Toggle({ id, label, checked, onChange, hint, dimKey }: { id: string; label: string; checked: boolean; onChange: (v: boolean) => void; hint?: string; /** şema etiketi anahtarı */ dimKey?: string }): JSX.Element {
  const hot = useHighlight((s) => s.dimKey);
  const setDim = useHighlight((s) => s.setDim);
  const leave = (): void => { if (dimKey && useHighlight.getState().dimKey === dimKey) setDim(null); };
  const cad = useCadForm();
  if (cad) {
    // Özellik ızgarasında açık/kapalı değer hücresi (README §4.9): hücreye tıklayınca anahtar
    return (
      <div className="cad-prop-row" data-hot={dimKey && hot === dimKey ? true : undefined} onMouseEnter={() => { if (dimKey) setDim(dimKey); }} onMouseLeave={leave}>
        <label htmlFor={id} className="cad-prop-label" title={hint ? `${label} — ${hint}` : label}>{label}</label>
        <div className="cad-prop-value">
          <button id={id} role="switch" type="button" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} onFocus={() => { if (dimKey) setDim(dimKey); }} onBlur={leave}
            className={`cad-prop-input text-left cursor-pointer ${checked ? "text-cad-snap" : "text-cad-ink3"}`}><span aria-hidden className="mr-1.5">{checked ? "☑" : "☐"}</span>{checked ? t("açık") : t("kapalı")}</button>
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-start gap-2 py-1" onMouseEnter={() => { if (dimKey) setDim(dimKey); }} onMouseLeave={leave}>
      <button id={id} role="switch" type="button" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} onFocus={() => { if (dimKey) setDim(dimKey); }} onBlur={leave}
        className={`relative w-9 h-5 shrink-0 rounded-full transition-colors ${checked ? "bg-accent" : "bg-rule"} ${dimKey && hot === dimKey ? "ring-2 ring-soil/40" : ""}`}>
        <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-sheet transition-all ${checked ? "left-[18px]" : "left-0.5"}`} />
      </button>
      <label htmlFor={id} className={`text-sm ${dimKey && hot === dimKey ? "text-soil" : ""}`}><div>{label}</div>{hint ? <div className="text-xs text-stone">{hint}</div> : null}</label>
    </div>
  );
}
